module.exports = __webpack_public_path__ + "media/images/not-active-a2eeacb4c4da860cb157e703e51c4c9b.png";